import { render, staticRenderFns } from "./AProgramacobrador.vue?vue&type=template&id=e4c120b8"
import script from "./AProgramacobrador.vue?vue&type=script&lang=js"
export * from "./AProgramacobrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports